import { ITourFareBookingTime } from "@interfaces";
import ftApiClient from "./ftApiClient";
import { getCachePlatform as getPlatform } from "./cacheRequestBrand";

export const cacheApi = {
    readProduct: (productId: string | number) => {
        return ftApiClient.get(`/cache/product/${productId}/read`);
    },

    readBookingDetails: (productPricesDetailsId: string | number) => {
        return ftApiClient.get<{ success: boolean; data: ITourFareBookingTime }>(
            `/cache/bookingdetails/${productPricesDetailsId}/read`,
        );
    },

    /**
     * Cache product details when user selects a product from home feed or search
     * @param productId - The product ID to cache
     * @param sessionId - Optional session ID for guest users
     */
    cacheProduct: (productId: string, sessionId?: string) => {
        const config = sessionId
            ? { params: { sessionId, platform: getPlatform() } }
            : { params: { platform: getPlatform() } };
        return ftApiClient.get(`/cache/product/${productId}`, config);
    },

    /**
     * Cache product availability when user selects a date in calendar
     * @param productId - The product ID
     * @param ppdId - Product price details ID
     * @param params - Required parameters for availability caching
     * @param sessionId - Optional session ID for guest users
     */
    cacheProductAvailability: (
        productId: string,
        ppdId: string,
        params: {
            apiProviderId: string;
            groupFaresForAvailabilityCheck: string;
            fareTypeId: string;
            bookingDate: string;
            timeId: string;
        },
        sessionId?: string,
    ) => {
        const finalParams = sessionId
            ? { ...params, sessionId, platform: getPlatform() }
            : { ...params, platform: getPlatform() };
        return ftApiClient.get(`/cache/product/${productId}/price/${ppdId}/details`, {
            params: finalParams,
        });
    },

    /**
     * Cache user resources - should be called periodically (every 4-5 minutes)
     * @param sessionId - Optional session ID for guest users
     */
    cacheUserResources: (sessionId?: string) => {
        const config = sessionId
            ? { params: { sessionId, platform: getPlatform() } }
            : { params: { platform: getPlatform() } };
        return ftApiClient.get("/cache/user/resources", config);
    },
};
